<div class="container-profile">
  <span class="title">Perfil</span>
  <div class="box-picture">
    <div *ngIf="user">
      <label for="avatar-upload" class="avatar-upload-label">
        <globot-profile-picture
          [name]="user.name"
          [imageUrl]="selectImage()"
          class="border-circle"
          [size]="72"
        >
        </globot-profile-picture>
        <span class="pi pi-camera"></span>
      </label>
      <input
        type="file"
        id="avatar-upload"
        style="display: none"
        (change)="fileChangeEvent($event)"
        accept=".jpg,.jpeg,.png"
      />
    </div>
    <div class="delete-box">
      <button *ngIf="hasPicture" class="btn-cancel" (click)="deletePicture()">Eliminar</button>
      <span>JPG o PNG. Tamaño máximo 1 MB.</span>
    </div>
  </div>

  <p-dialog
    [header]="'Ajustar imagen'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
  >
    <image-cropper
      *ngIf="!imageUploaded"
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      [aspectRatio]="1"
      [roundCropper]="true"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
      style="max-width: 320px"
    ></image-cropper>
    <div *ngIf="croppedImage && !imageUploaded" class="button-group">
      <button (click)="cancelImageUpload()" [disabled]="isLoading" class="btn-cancel">
        Cancelar
      </button>
      <button (click)="uploadCroppedImage()" class="btn-update" [disabled]="isLoading">
        <span>Aplicar</span>
        <p-progressSpinner
          *ngIf="isLoading"
          [style]="{ width: '18px', height: '18px' }"
          ariaLabel="loading"
        ></p-progressSpinner>
      </button>
    </div>
  </p-dialog>

  <div>
    <form class="bodyForm" [formGroup]="userForm" *ngIf="user">
      <div class="flex-auto">
        <label for="email"> Email </label>
        <input
          pInputText
          type="text"
          formControlName="email"
          id="email"
          [readonly]="true"
          style="background: #e5e9ee; color: var(--color-text)"
        />
      </div>
      <div class="flex-auto">
        <label for="name"> Nombre para mostrar </label>
        <input
          pInputText
          formControlName="name"
          id="name"
          formControlName="name"
          placeholder="Tu nombre completo"
          [ngClass]="getInputClass('name')"
        />
      </div>
      <div class="box-button">
        <globot-button
          text="Guardar"
          styleClass="raised"
          [loading]="isUpdating"
          (clickEvent)="updateUser()"
          width="w-100"
          iconPosition="right"
          [disabled]="!userForm.valid || !userForm.dirty"
        >
        </globot-button>
      </div>
    </form>
  </div>
</div>
<p-confirmDialog #confirmD key="deletePictureDialog">
  <ng-template pTemplate="header">
    <h1>Eliminar foto de perfil</h1>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="confirmD.reject()"
    ></button>
    <button
      type="button"
      pButton
      label="Eliminar"
      class="p-button-danger"
      (click)="confirmD.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
